export enum PAYMENT_METHODS {
    PayPal = 'paypal',
    CreditCard = 'credit-card'
}
